import React from "react";
import SvgIcon from '@material-ui/core/SvgIcon';

function GraphIcon(props) {
  return (
    <SvgIcon xmlns="http://www.w3.org/2000/svg" width="13.406" height="12.944" viewBox="0 0 13.406 12.944" {...props}>
      <defs>
        <style>
          {`.cls-1{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.75px}`}
        </style>
      </defs>
      <g id="Group_6315" transform="translate(-713.357 -1237.317)">
        <path id="Rectangle_1677" d="M725.842 1254.633a108.257 108.257 0 0 1-11.565 0" class="cls-1" transform="translate(0 -5.402)"/>
        <path id="Line_416" d="M0 0L0 5.943" class="cls-1" transform="translate(723.745 1240.065)"/>
        <path id="Line_417" d="M0 0L0 7.816" class="cls-1" transform="translate(720.115 1238.192)"/>
        <path id="Line_418" d="M0 0L0 3.274" class="cls-1" transform="translate(716.485 1242.735)"/>
      </g>
    </SvgIcon>
  );
}

export default GraphIcon;


// WEBPACK FOOTER //
// ./src/components/icons/GraphIcon.jsx